<template>
  <div id="I-APC">
    <vs-row vs-w="12">
      <vs-col
        vs-w="12"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
        vs-type="flex"
        vs-justify="center"
      >
        <vs-row vs-w="12">
          <!-- Frist Card -->
          <CardFrist />
          <vs-space></vs-space>

          <!-- dropdown -->
          <vs-row>
            <h4 class="mt-2">Temperature & Humidity</h4>
            <vs-spacer></vs-spacer>
            <vs-select v-model="select1" width="120px" @change="upDateChart">
              <vs-select-item
                :key="index"
                :value="item"
                :text="item"
                v-for="(item, index) in options1"
              />
            </vs-select>
          </vs-row>
          <br />
          <vs-card vs-lg="4" class="cardBorder" id="card_chart">
            <vs-row>
              <vs-icon
                icon="device_thermostat"
                size="30px"
                bg="#E4F9E6"
                round
                color="#F7D225"
              ></vs-icon>
              <h4 class="mt-1 ml-2">Temperature</h4>
            </vs-row>

            <Chart
              v-if="temp.value.length > 0"
              :chartdata="temp"
              :height="heightChart"
              :color="'#ffc107'"
              :areaColor="'#ffd966a1'"
              class="mt-3"
            />
          </vs-card>
          <!-- <h4 class="mb-4">Power Condition Usage</h4> -->
          <vs-card vs-lg="4" class="cardBorder" id="card_chart">
            <vs-row>
              <vs-icon
                icon="linear_scale"
                size="30px"
                bg="#E4F9E6"
                round
                color="#25A5E1"
              ></vs-icon>
              <h4 class="mt-1 ml-2">Humidity</h4>
            </vs-row>
            <Chart
              v-if="hum.value.length > 0"
              :chartdata="hum"
              :height="heightChart"
              :color="'#25A5E1'"
              :areaColor="'#5bbfee85'"
              class="mt-3"
          /></vs-card>
        </vs-row>
      </vs-col>

      <!-- Card Floor -->
      <vs-col
        vs-w="12"
        vs-lg="6"
        vs-sm="12"
        vs-xs="12"
        vs-type="flex"
        vs-justify="center"
      >
        <vs-row vs-lg="12" vs-sm="12" vs-xs="12">
          <div
            class="card-floor"
            v-for="(item, index) in $store.getters['i_APC/floor']"
            :key="index"
          >
            <CardFloor
              :title="item"
              :floorIndex="(index % 4) + 1"
              :numDevice="numDevice[index]"
            />
          </div>
        </vs-row>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import Chart from "./components/chart.vue";
import CardFloor from "./components/CardFloor.vue";
import CardFrist from "./components/CardFrist.vue";

export default {
  data() {
    return {
      options1: ["Day", "Week", "Month"],
      // numDevice: [{light:1,air:2},{light:1,air:1},{light:1,air:1},{light:1,air:2}],
      select1: "Day",
      switch1: true,
      blue: "rgb(251,186,85,.2)",
      red: "rgb(76,183,252,.2)",
      val3: 50,
      url: "@/assets/images/i-APC/bg_floor_2.png",
      temp: { value: [], labels: [], tooltip_label: "Temperature ( °C )" },
      hum: { value: [], labels: [], tooltip_label: "Humidity ( % )" },
      heightofchart: 300,
      numDevice: [
        {
          light: ["light_1-2"],
          air: ["air_iapc1_1", "air_iapc1_2"],
          breaker: ["breaker_1-2"],
        },
        {
          light: ["light_1-2"],
          air: [],
          breaker: ["breaker_1-2"],
        },
        {
          light: ["light_3-4"],
          air: ["air_iapc3_1", "air_iapc3_2"],
          breaker: ["breaker_3"],
        },
        {
          light: ["light_3-4"],
          air: ["air_iapc4_1", "air_iapc4_2"],
          breaker: ["breaker_4"],
        },
      ],
    };
  },
  components: {
    Chart,
    CardFloor,
    CardFrist,
  },
  computed: {
    heightChart: {
      get() {
        return this.heightofchart;
      },
      set(newValue) {
        this.heightofchart = newValue;
      },
    },
  },
  mounted() {
    this.getTempHum();
    // this.feckTempHum();
    this.$store.dispatch("i_APC/getSensor");

    // let cardchart = document.getElementById('card_chart')
    // console.log("cardchart",cardchart.clientHeight);
    // this.heightofchart = cardchart.clientHeight
    // this.heightChart(cardchart.clientHeight)
  },
  methods: {
    upDateChart() {
      console.log(this.select1);
      this.getTempHum();
    },
    async feckTempHum() {
      let count = 0;
      this.temp = { value: [], labels: [], tooltip_label: "Temperature ( °C )" };
      this.hum = { value: [], labels: [], tooltip_label: "Humidity ( % )" };
      switch (this.select1) {
        case "Day":
          let start = parseInt(this.$moment().format("YYYMMDD00"));
          let end = parseInt(this.$moment().format("YYYMMDDHH"));
          count = end - start;
          break;
        case "Week":
          count = 7;
          break;
        case "Month":
          count = 12;
          break;
      }
      let valueT = [];
      let valueH = [];
      let label = [];
      for (let i = count - 1; i >= 0; i--) {
        let vt = Math.floor(Math.random() * (27 - 23) + 23);
        let vh = Math.floor(Math.random() * (60 - 45) + 45);
        let l;
        if (this.select1 == "Day") {
          l = this.$moment().subtract(i, "hours").format("HH:mm");
        } else if (this.select1 == "Week") {
          l = this.$moment().subtract(i, "days").format("MM-DD");
        } else if (this.select1 == "Month") {
          l = this.$moment().subtract(i, "hours").format("MMM YY");
        }
        // valueT.push(vt)
        // valueH.push(vh)
        // label.push(l)
        this.temp.value.push(vt);
        this.temp.labels.push(l);

        this.hum.value.push(vh);
        this.hum.labels.push(l);
      }
      console.log(valueT, label);
      // this.temp.value = valueT
      // this.temp.labels = label
      // this.hum.value = valueH
      // this.hum.labels = label
    },
    async getTempHum() {
      this.temp = { value: [], labels: [], tooltip_label: "Temperature ( °C )" };
      this.hum = { value: [], labels: [], tooltip_label: "Humidity ( % )" };
      let time_end = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      let time_start;
      switch (this.select1) {
        case "Day":
          time_start = this.$moment().format("YYYY-MM-DD 00:00:00");
          break;
        case "Week":
          time_start = this.$moment(
            new Date().getTime() - 6 * 24 * 60 * 60 * 1000
          ).format("YYYY-MM-DD 00:00:00");
          break;
        case "Month":
          time_start = this.$moment(
            new Date().getTime() - 29 * 24 * 60 * 60 * 1000
          ).format("YYYY-MM-DD 00:00:00");
          break;

        default:
          time_start = this.$moment().format("YYYY-MM-DD 00:00:00");
          break;
      }
      console.log(time_start, time_end);
      let body = {
        start: time_start,
        end: time_end,
      };
      let res = await this.$API.post("tuya/graph/overview", body);
      console.log(res);
      if (res.status == 200) {
        for (let i = 0; i < res.data.length; i++) {
          const el = res.data[i];
          this.temp.value.push(el.temp);
          this.temp.labels.push(
            this.$moment(el.timestamp).format("DD-MM HH:mm")
          );
          this.hum.value.push(el.humid);
          this.hum.labels.push(
            this.$moment(el.timestamp).format("DD-MM HH:mm")
          );
        }
      }
      console.log(this.temp, this.hum);
    },
  },
};
</script>

<style lang="scss" scoped>
$width-card: 150px;
$height-card: 150px;

.cardBorder {
  border-radius: 20px;
  color: #5bbfee7a;
}
// .cardBordercolor {
//   border-radius: 35px;
//   border-style: solid;
//   border-color: #6fda79;
// }
// .stack {
//   position: relative;
//   top: 15px;
//   right: 110px;
// }
.card-floor {
  width: 100%;
  // height: auto;
  // display: block;
  // background: #ffffff;
  // margin-bottom: 1rem;
  img {
    width: 100%;
  }
  .content-card {
    // position: absolute;
    // top: 0%;

    border-radius: 20px;
    background-image: url("../../../../../assets/images/i-APC/bg_floor_1.png");
    background-repeat: no-repeat;
    background-size: cover;
    p {
      font-size: 0.7rem;
    }
  }
}
.card-light {
  border: #007bff 1px solid;
  border-radius: 20px;
  padding: 10px;
  margin: 0 10px 10px 0;
  background-color: #ffffff;
  width: 120px;
  height: 120px;
}

.card-air {
  // border: #ffc107 1px solid;
  border-radius: 5000px;
  padding: 10px;
  margin: 0 10px 10px 0;
  background-color: #ffffff;
  width: 120px;
  height: 120px;
  display: flex;
  justify-content: center;
  align-items: center;
  .item-air {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
    top: -15px;
    right: 30px;

    .stack {
      display: block;
      position: relative;
      top: 25px;
      right: 90px;
      // box-shadow: 1px 1px 3px 0.5px #cecece;
      border-radius: 500px;
      height: 100px;
      width: 100px;
      .img {
        // display: block;
      }
      p {
        text-align: center;
        margin-bottom: 2px;
      }
    }
  }
}
</style>